import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorScreen } from '@account-services-mfe/core';
import { PaymentSecurityScreens } from '../typings';
import Enrolled from '../ui/components/modal/content/already-enrolled';
import Pending from '../ui/components/modal/content/pending-enrollment';
import Unenrolled from '../ui/components/modal/content/not-enrolled';
import Cancelled from '../ui/components/modal/content/cancelled';
import EnrollmentSuccess from '../ui/components/modal/content/enrollment-success';
import DeniedEnrollment from '../ui/components/modal/content/denied-enrollment';
const displayModalScreen = (screenType) => {
    const modalScreenMap = {
        [PaymentSecurityScreens.CANCELLED]: _jsx(Cancelled, {}),
        [PaymentSecurityScreens.ENROLLED]: _jsx(Enrolled, {}),
        [PaymentSecurityScreens.ENROLLMENT_SUCCESS]: _jsx(EnrollmentSuccess, {}),
        [PaymentSecurityScreens.DENIED_ENROLLMENT]: _jsx(DeniedEnrollment, {}),
        [PaymentSecurityScreens.GENERIC_ERROR]: (_jsx(ErrorScreen, { id: "payment-security-generic-error" })),
        [PaymentSecurityScreens.PENDING]: _jsx(Pending, {}),
        [PaymentSecurityScreens.UNENROLLED]: _jsx(Unenrolled, {})
    };
    return modalScreenMap[screenType] || null;
};
export default displayModalScreen;
